import { observer } from 'mobx-react-lite'
import { RemoveCouponAsAdminDialog } from '@/features/jobs/RemoveCouponAsAdminDialog'
import { type RemoveCouponAsAdminDialogViewModel } from './RemoveCouponAsAdminDialogViewModel'

export interface RemoveCouponAsAdminDialogContainerProps {
  vm: RemoveCouponAsAdminDialogViewModel
}

export const RemoveCouponAsAdminDialogContainer = observer(
  function RemoveCouponAsAdminDialogContainer({
    vm,
  }: RemoveCouponAsAdminDialogContainerProps) {
    return (
      <RemoveCouponAsAdminDialog
        showing={vm.modal.showing}
        couponDisplay={vm.couponDisplay}
        isRemovePending={vm.removeCouponAsAdmin.pending}
        onClose={vm.modal.close}
        onRemoveCoupon={vm.removeCouponAsAdmin}
        submitButtonTestId="remove-coupon-as-admin-submit-button"
      />
    )
  },
)
